import type { FieldErrors } from 'react-hook-form';

import type { Renter } from '@/utils/types/renter.interface';
import type { ValidationResult } from '../RenterInvite.types';

export const DUPLICATE_APPLICANT_EMAIL_ERROR_MESSAGE =
  'Some renters seem to share the same email. Please check again.';

export const isDuplicateApplicantEmail = (
  applicantEmails: Renter['applicantEmails'] | undefined,
  index: number,
): boolean => {
  const value = applicantEmails?.[index]?.value?.toLowerCase();
  if (!value) return false;

  const matchingCount = applicantEmails?.filter(
    (email) => email.value?.toLowerCase() === value,
  ).length;
  return (matchingCount ?? 0) > 1;
};

export const getApplicantEmailErrorMessage = (
  errors: FieldErrors<Renter>,
  applicantEmails: Renter['applicantEmails'] | undefined,
  index: number,
): string => {
  const errorMessage = errors?.applicantEmails?.[index]?.value?.message;
  if (errorMessage) return errorMessage;

  return isDuplicateApplicantEmail(applicantEmails, index)
    ? DUPLICATE_APPLICANT_EMAIL_ERROR_MESSAGE
    : '';
};

export const getApplicantEmailValidationResult = (
  applicantEmails: Renter['applicantEmails'] | undefined,
  index: number,
  isFieldValid: boolean,
): ValidationResult => {
  if (isDuplicateApplicantEmail(applicantEmails, index)) return 'duplicate_application';
  if (isFieldValid) return 'valid';
  return 'invalid_format';
};
